import type { ListOutput } from '@allocab/allocab-standard-shared-types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  ExtranetIncidentOutput,
  ExtranetIncidentsListInput,
  PageableRangeInput,
} from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { toPageableRangeInput } from '../mappers';
import { extranetQueryKeys } from '../queryKeys';

// `search`, `sortBy`, `sortDir`, `status[]`, `category[]`, `priority[]` ne sont
// pas supportés par `/v1/incidents` : conservés dans l'input front pour le
// tri/filtre client, ignorés côté call API.
//
// Note : `ExtranetIncidentOutput` inclut déjà ride/timeline/attachments inline —
// donc pas d'endpoint detail séparé.
export const useExtranetIncidentsList = (input: ExtranetIncidentsListInput) =>
  useQuery<ListOutput<ExtranetIncidentOutput>>({
    queryKey: extranetQueryKeys.incidents.list(input),
    queryFn: () =>
      getExtranetApi().get<PageableRangeInput, ListOutput<ExtranetIncidentOutput>>(
        '/v1/incidents',
        toPageableRangeInput(input, {
          offset: input.page && input.limit ? (input.page - 1) * input.limit : undefined,
          limit: input.limit,
        }),
      ),
    enabled: Boolean(input.dateRange?.from && input.dateRange?.to),
    placeholderData: keepPreviousData,
  });
